import React from 'react';
import InputWithLabel from '../../shared/components/InputWithLabel';


const LoginPageInput = ({mail,setMail,password,setPassword}) => {
  return (
    <>
    <InputWithLabel
    value={mail}
    setValue={setMail}
    label="E-mail"
    type="text"
    placeholder="Введите e-mail"
    />
    <InputWithLabel
    value={password}
    setValue={setPassword}
    label="Пароль"
    type="password"
    placeholder="Введите пароль"
    />
      
    </>
  )
}

export default LoginPageInput
